var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-data-table", {
        staticClass: "elevation-2 no-show-permission",
        attrs: {
          headers: _vm.headers,
          items: _vm.requestFields,
          page: _vm.pagination.page,
          "items-per-page": _vm.paginationReservationTemplateField.rowsPerPage,
          loading: _vm.loading,
          "loading-text": "",
          "items-per-page-text": _vm.rowsPerPageText,
          "items-per-page-items": _vm.rowsPerPageItems,
          "header-props": { sortIcon: _vm.sortIcon },
          "footer-props": {
            prevIcon: _vm.prevIcon,
            nextIcon: _vm.nextIcon,
            "items-per-page-options": _vm.rowsPerPageItems
          }
        },
        on: {
          "update:page": function($event) {
            return _vm.$set(_vm.pagination, "page", $event)
          },
          "update:itemsPerPage": function($event) {
            return _vm.$set(
              _vm.paginationReservationTemplateField,
              "rowsPerPage",
              $event
            )
          },
          "update:items-per-page": function($event) {
            return _vm.$set(
              _vm.paginationReservationTemplateField,
              "rowsPerPage",
              $event
            )
          },
          pagination: function($event) {
            return _vm.setRowsOnLocalStorage(
              _vm.dataTableReservationTemplateFieldId,
              _vm.paginationReservationTemplateField.rowsPerPage
            )
          }
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", [
                    _vm._v(_vm._s(props.item.request_form_field.label))
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(props.item.artf_default_value))]),
                  _vm._v(" "),
                  _vm.userCanEditOrRemoveItems
                    ? _c(
                        "td",
                        [
                          _c("app-datatable-action-buttons", {
                            attrs: {
                              "user-can-edit": true,
                              "user-can-delete": true
                            },
                            on: {
                              edit: function($event) {
                                return _vm.$emit("edit-item", props.index)
                              },
                              delete: function($event) {
                                return _vm.askConfirmationToDeleteItem(
                                  props.item
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            }
          },
          {
            key: "pageText",
            fn: function(props) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(props.pageStart) +
                    " - " +
                    _vm._s(props.pageStop) +
                    " " +
                    _vm._s(_vm.$t("tables.Of")) +
                    "\n      " +
                    _vm._s(props.itemsLength) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "no-data",
            fn: function() {
              return [_vm.loading ? _c("div") : _vm._e()]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.deleteDialog,
          title: _vm.$t("Delete"),
          content: _vm.$t("DeleteConfirmation") + "?",
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes")
        },
        on: { mainAction: _vm.cancelDelete, secondaryAction: _vm.confirmDelete }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d821fb2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d821fb2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssetReservationManagement/Templates/ReservationTemplateFieldsList.vue
// module id = null
// module chunks = 